<app-header [title]="'Employee Report'"></app-header>
<ion-content class="employee-report">

    <ng-container>

        <div class="loading-container" style="padding-top:15%" *ngIf="!loaded">
            <ion-spinner></ion-spinner>
        </div>
        <ion-grid *ngIf="!ShowSuccessMessage">
            <ion-row *ngIf="doneLoading">
                <ion-col>
                    <ion-grid>
                        <div class="table-container">
                            <ion-row class="cust-info-row">
                                <ion-col size="auto">

                                    <ion-row>
                                        <ion-col>
                                            Customer:&nbsp;{{customer?.customerCode}}&nbsp;&nbsp;<b>{{customer?.customerName}}</b>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            Department:&nbsp;{{customer?.departmentCode}}&nbsp;&nbsp;<b>{{customer?.departmentName}}</b>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            Employee:
                                            &nbsp;{{customer?.employeeCode}}&nbsp;&nbsp;<b>{{customer?.lastName}}, {{
                                                customer?.firstName}} </b>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            Stop: &nbsp;{{customer?.stopCode}}&nbsp;&nbsp;<b>{{customer?.stopName}}</b>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            Garment ID Label: &nbsp;{{customer?.stopCode}}&nbsp;{{customer?.lockerNum}}
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-button color="gallaghergreen" class="btn-box-shadow"
                                                (click)="openWeeklyHistoryModal(report.employeeListing)"><span>View
                                                    Weekly History</span></ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-col>
                                <ion-col>
                                    <div style="float:right">
                                        <ion-row>
                                            Report Date: {{ currentDate | date:'MM/dd/yyyy'}}
                                        </ion-row>
                                        <ion-row>
                                            <button class="printer-button hidden-for-print"
                                                (click)="changePrinterView()">{{viewChange === true ? 'Regular Version'
                                                : 'Printer Friendly Version'}}</button>
                                        </ion-row>
                                        <ion-row *ngIf="IsCancelEmpAllow">
                                            <ion-button color="gallaghergreen" class="btn-box-shadow"
                                                style="margin-top:10px" (click)="submitCancelItem()"><span>Cancel
                                                    Employee</span></ion-button>
                                        </ion-row>
                                    </div>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <ion-row>
                                        <ion-col class="label-col">
                                            <ion-label><strong>Garment Summary</strong></ion-label>
                                        </ion-col>
                                    </ion-row>
                                    <app-garment-summary-table [rows]="report.summary"
                                        [class.hidden]="viewChange"></app-garment-summary-table>
                                    <app-garment-summary-table-print [rows]="report.summary"
                                        [class.hidden]="!viewChange"></app-garment-summary-table-print>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="report.woCount>0">
                                <ion-col style="font-size:14px"><span style="color:red; margin-left:10px">*Note:
                                    </span>This Employee has Open Work Orders.<a
                                        (click)="openWorkOrder(report.employeeListing)"
                                        style="text-decoration: underline; cursor: pointer;color: #007bff;"> Click
                                        here</a> to view Work Orders.</ion-col>
                            </ion-row>
                            <ion-row *ngIf="summaryNotes.length > 0">
                                <ion-col>
                                    <ion-row>
                                        <ion-col class="label-col">
                                            <ion-label><strong>Notes</strong></ion-label>
                                        </ion-col>
                                    </ion-row>
                                    <app-garment-notes-summary-table [garmentNotes]="garmentSummaryStatusCodes"
                                        [rows]="summaryNotes"></app-garment-notes-summary-table>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <ion-row>
                                        <ion-col class="label-col">
                                            <ion-label><strong>Garment Details</strong></ion-label>
                                        </ion-col>
                                    </ion-row>
                                    <app-garment-detail-table [rows]="report.details"
                                        *ngIf="!viewChange"></app-garment-detail-table>
                                    <app-garment-detail-table-print [rows]="report.details"
                                        *ngIf="viewChange"></app-garment-detail-table-print>
                                </ion-col>
                            </ion-row>
                        </div>
                    </ion-grid>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="report?.notes.length > 0" style="width: 94%;margin-left: 3%;">
                <ion-col>
                    <ion-row>
                        <ion-col class="label-col">
                            <ion-label><strong>Notes</strong></ion-label>
                        </ion-col>
                    </ion-row>
                    <app-garment-notes-table [rows]="report?.notes"></app-garment-notes-table>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div style="max-width: 600px; margin: 40px auto; text-align: center; margin-top: 150px;" *ngIf="ShowSuccessMessage">
            <p>Cancel Work Order Created Successfully for Employee:
                &nbsp;<b>{{customer?.lastName}}, {{ customer?.firstName}}</b></p>
            <p>Work Order Number: <strong>{{ workOrderNumber }}</strong></p>
            <p>
                <a href="javascript:void(0)" (click)="goToMainScreen()">Click here to continue</a>
            </p>
        </div>
    </ng-container>
</ion-content>